import { render, staticRenderFns } from "./registrationCorpClient.vue?vue&type=template&id=a57137b8&scoped=true"
import script from "./registrationCorpClient.vue?vue&type=script&lang=js"
export * from "./registrationCorpClient.vue?vue&type=script&lang=js"
import style0 from "./registrationCorpClient.vue?vue&type=style&index=0&id=a57137b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57137b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VSelect,VTextField})
